module.exports = __webpack_public_path__ + "img/service3-3.a950ff05.jpg";